import { ApiClient } from '../../../api-client';

import { IAppConfigurationResponse } from './types';
import { appConfigurationUrl } from './urls';

/**
 * This is provides the API client methods for all App Config api calls
 * Eg: Get Contact Information, App Configurations etc
 *
 */
export class AppConfigAPIClient extends ApiClient {
  private static classInstance?: AppConfigAPIClient;

  private constructor() {
    super({
      apiBaseURL: 'APP_CONFIG_BASE_URL',
    });
  }

  /**
   * Applying the dreaded singleton pattern here to reuse the axios instance.
   */
  public static getClientInstance = () => {
    if (!this.classInstance) {
      this.classInstance = new AppConfigAPIClient();
    }

    return this.classInstance;
  };

  /**
   * Api call to fetch App Configurations
   *
   * @returns IAppConfigurationResponse
   */
  public fetchAppConfigurations = async () => {
    const response = await this.get<IAppConfigurationResponse>(
      appConfigurationUrl(),
      {
        requiresAuth: false,
      }
    );

    if (!response.success) throw response;

    return response?.data;
  };
}

/**
 * This creates a new instance of the class. is th base Axios API client Class
 * wrapper for All App Config api requests.
 */
export const APP_CONFIG_API = AppConfigAPIClient.getClientInstance();
